module.exports = __webpack_public_path__ + "img/p005.2e297dc4.png";